import React from 'react';
import {Helmet} from 'react-helmet';
import Header from '../components/layout/MainLayout/Header';
import Footer from '../components/layout/MainLayout/Footer';

import Shutter from '../assets/img/png/screenshot1.png';
import DotPattern from '../assets/img/svg/dot-pattern.svg';
import {scrollTop} from '../utils/scrollTop';

const Intro = () => {
    return (
        <section className="intro">
            <div className="tier_one">
                <div className="container">
                    <div className="h3ro">
                        <h1>Coming Soon</h1>
                        <p>
                            MySpotLyt is a social media platform for Scouts and Talent
                            Discovery. We give Talents the opportunity to stand out from
                            the crowd and also enable Scouts to identify new stars.
                        </p>
                    </div>
                    <div className="deco">
                        <img src={Shutter} alt="shutter" width="65%" />
                        <img className="pattern" src={DotPattern} alt="pattern" />
                    </div>
                </div>
            </div>
        </section>
    );
};

const ComingSoon = () => {
    scrollTop();

    return (
        <>
            <Helmet>
                <title>App Coming Soon!</title>
            </Helmet>
            <Header />
            <main className="plublic">
                <Intro />
            </main>
            <Footer />
        </>
    );
};

export default ComingSoon;
